import { useEffect } from 'react';
import InputDiv from './InputDiv';
import Hyperlink from './Hyperlink';
import Button from './Button';
import * as Yup from "yup";
import { Formik, Form } from "formik";
import { useMutation } from 'react-query';
import axios from "axios";
import FormContainer from './FormContainer';
import ENV from '../constants/envConstants';
import forEach from 'lodash/forEach';
import { useNavigate } from "react-router";
import Loader from './Loader';
import { handle500, handleUnknown } from '../utils/errorHandles';
import FieldGrid from './FieldGrid';
import FieldGridItem from "./FieldGridItem";
import { identifySegment, trackEventSegment } from "../utils/segmentUtils";
import { Helmet } from 'react-helmet';
import dayjs from "dayjs";
import { useCsrf } from "../api/queries";
import { useUser } from "../api/queries";

const createUser = (data) => {
    const { values } = data;
    return axios.post(
        ENV.BACKEND_URL + '/restaurants/users/register/',
        values
    )
}

const UserRegistrationPage = (props) => {
  const initialData = {
    firstName: "",
    email: "",
    password1: "",
    password2: "",
  };

  const [mutate] = useMutation(createUser);

  let navigate = useNavigate();

  const req = useCsrf();

  const { data: user } = useUser();

  const schema = Yup.object({
    firstName: Yup.string().required("This field is required."),
    email: Yup.string().required("This field is required.").email("Please enter a valid email."),
    password1: Yup.string().required("This field is required."),
    password2: Yup.string().oneOf([Yup.ref("password1"), null], "Passwords must match"),
  });

  const djTojsDict = {
    name: "firstName",
    email: "email",
    password1: "password1",
    password2: "password2",
  };

  const onSubmit = async (values, bag) => {
    await mutate(
      {
        values: {
          email: values.email,
          name: values.firstName,
          password1: values.password1,
          password2: values.password2,
        },
      },
      {
        onSuccess: (data) => {
          identifySegment(data.data.user.uuid, {
            name: values.firstName,
            email: values.email,
            id: data.data.user.uuid,
            createdAt: dayjs().unix(),
          });
          trackEventSegment("Created account");
          navigate("/business-profile");
        },
        onError: (error) => {
          const status = error.response.status;
          const data = error.response.data;
          switch (status) {
            case 400:
              if (data.error_type === "ValidationError") {
                forEach(data.errors, (error) => {
                  bag.setFieldError(djTojsDict[error.field], error.message);
                });
              } else {
                handleUnknown();
              }
              break;
            case 500:
              handle500();
              break;
            default:
              handleUnknown();
              break;
          }
        },
      }
    );
    bag.setSubmitting(false);
  };

  useEffect(() => {
    props.setHeader("Create account");
    props.setSubheader("Fill out your details to create your eatsee account");
    return () => {
      props.setHeader("");
      props.setSubheader("");
    };
  }, [props]);

  if (user) {
    navigate("/business-profile");
  }

  return (
    <FormContainer>
      <Helmet>
        <title>Eatsee - Get started</title>
      </Helmet>
      <Formik initialValues={initialData} onSubmit={onSubmit} validationSchema={schema}>
        {(formik) =>
          formik.isSubmitting ? (
            <Loader type={"beat"} size={20} />
          ) : (
            <Form>
              <InputDiv text="Full name" name="firstName" />
              <InputDiv text="Email address" name="email" />
              <FieldGrid>
                <FieldGridItem>
                  <InputDiv type="password" text="Password" name="password1" />
                </FieldGridItem>
                <FieldGridItem>
                  <InputDiv type="password" text="Confirm password" name="password2" />
                </FieldGridItem>
              </FieldGrid>
              <Button type="submit" text="Create my account" />
              <Hyperlink href="https://dashboard.eatsee.menu" text="Already have an account? Sign in" />
            </Form>
          )
        }
      </Formik>
    </FormContainer>
  );
};

export default UserRegistrationPage;
